module.exports = __webpack_public_path__ + "img/rentabilidad.33088f86.png";